import { FC } from 'react'
import { MdMoreVert } from 'react-icons/md'

import { cn } from 'src/lib/cn'
import useSelectedDashboardStore from 'src/stores/useSelectedDashboardStore'
import IconButton from '../../atoms/IconButton'
import PopupButton from '../../atoms/PopupButton'
import { PopupButtonContext } from '../../atoms/PopupButton/PopupButtonProvider'
import { usePageHeaderContext } from '../PageHeader/PageHeaderProvider'
import PageHeaderDashboardMenuModals from './components/modals/PageHeaderDashboardMenuModals'
import PageHeaderDashboardMenuPopup from './PageHeaderDashboardMenuPopup'
import { PageHeaderDashboardMenuProvider } from './PageHeaderDashboardMenuProvider'

const PageHeaderDashboardMenu: FC = () => {
  const { exportDashboardComponentCode, printModeAllowed } = usePageHeaderContext()
  const selectedDashboard = useSelectedDashboardStore(s => s.selectedDashboard)
  const isDefaultDashboard = selectedDashboard?.default_dashboard

  const isWithAction = selectedDashboard && !isDefaultDashboard

  const hasNoData = !exportDashboardComponentCode && !printModeAllowed && !isWithAction

  if (hasNoData) {
    return null
  }

  return (
    <div className="block">
      <PageHeaderDashboardMenuProvider>
        <PageHeaderDashboardMenuModals />
        <PopupButton
          isLazy
          openOnHover
          data-testid="header-dashboard-menu"
          popupComponent={<PageHeaderDashboardMenuPopup />}
          buttonComponent={
            <PopupButtonContext.Consumer>
              {popupProps => (
                <IconButton
                  noBorder
                  className={cn(
                    'text-rolling-stone bg-porcelain ml-0 size-[25px] rounded-sm',
                    popupProps?.isOpen && 'text-black',
                  )}
                >
                  <MdMoreVert size={20} />
                </IconButton>
              )}
            </PopupButtonContext.Consumer>
          }
          classes={{ Popup: 'bg-white w-fit shadow-popup! rounded-xl min-w-44 mt-1!' }}
          popupFixedProps={{ anchorOrigin: 'left' }}
          needToPassChildToggleProps={false}
          mouseLeaveActiveDirection="down"
        />
      </PageHeaderDashboardMenuProvider>
    </div>
  )
}

export default PageHeaderDashboardMenu
